import React, { useEffect, useState } from "react";
import { Badge, Card, Form, Label, Spinner } from "reactstrap";
import { BiEdit, BiMinus, BiPlus } from "react-icons/bi";
import MyDataTable from "../../myComponents/DataTable/MyDataTable";
import { useForm } from "react-hook-form";
import ImageUpload from "../../myComponents/form/ImageUpload";
import useLogout, { ValidateImg } from "../../utils/Utils";
import Select from "react-select";
import { addMngmntDirAPI, editManageDirAPI, getManageDirAPI } from "../../api/banner";
import ViewImage from "../../myComponents/modals/ViewImage";
import { toast } from "react-toastify";
import ConfirmModal from "../../myComponents/modals/ConfirmModal";
import { deleteMgmntDirStatusAPI, updateMenuStatusAPI, updateMgmntDirStatusAPI } from "../../api/menu";
import { decrypt, encrypt, encryptFormData } from "../../utils/Encrypt";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../components/Component";
import MyCreatableInput from "../../myComponents/form/MyCreatableInput";
import { DeleteModal } from "../../myComponents/modals/DeleteModal";

const MgmntDirectry = () => {
  const logout = useLogout();
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [mode, setMode] = useState("Add");
  const IMAGE_BASE_URL = localStorage.getItem("IMAGE_BASE_URL");
  const [data, setData] = useState([]);
  const [imageOpen, setImageOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  const [column, setColumn] = useState([
    {
      name: "Name",
      selector: (row) => `${row?.en_first_name || ""} ${row?.en_last_name || ""}`,
      sortable: true,
      wrap: true,
    },
    {
      name: "Name- Hindi",
      selector: (row) => `${row?.hn_first_name || ""} ${row?.hn_last_name || ""}`,
      sortable: true,
      wrap: true,
    },
    {
      name: "Designation",
      selector: (row) => row?.en_designation,
      sortable: true,
      wrap: true,
    },
    {
      name: "Designation -Hindi",
      selector: (row) => row?.hn_designation,
      sortable: true,
      wrap: true,
    },
    {
      name: "E-mail",
      selector: (row) => row?.email,
      sortable: true,
      wrap: true,
    },
    {
      name: "Phone",
      selector: (row) => row?.phone,
      sortable: true,
      wrap: true,
    },
    {
      name: "Order",
      selector: (row) => row?.order,
      sortable: true,
      wrap: true,
    },
    {
      name: "Image",
      selector: (row) => (
        <div onClick={() => handleImageOpenPreview(`${IMAGE_BASE_URL}` + row?.img)}>
          <img style={{ width: "50px" }} src={`${IMAGE_BASE_URL}` + row.img} />
        </div>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
          <Badge color={`${row?.status ? "success" : "danger"}`}>{row?.status ? "Active" : "InActive"}</Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Action",
      wrap: true,
      cell: (row) => (
        <div>
          <Button outline color={`warning`} size={`xs`} className={`me-1`} onClick={() => handleEdit(row)}>
            <Icon name="edit" />
          </Button>
          <Button outline color={`danger`} size={`xs`} onClick={() => toggleDelete(row)}>
            {" "}
            <Icon name="trash"></Icon>
          </Button>
        </div>
      ),
    },
  ]);

  const {
    register,
    handleSubmit,
    control,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    getValues,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      upload_image: null,
    },
  });

  const handleEdit = (row) => {
    window.scrollTo(0, 0);
    setIsOpen(!isOpen);
    setMode("Edit");
    setValue("id", row.id); // Add this for consistent `formData` structure
    setValue("name", row.en_first_name);
    setValue("name_hindi", row.hn_first_name);
    setValue("l_name", row.en_last_name);
    setValue("l_name_hindi", row.hn_last_name);
    setValue("designation", row.en_designation);
    setValue("designation_hindi", row.hn_designation);
    setValue("emails", row.email);
    setValue("phones", row.phone);
    // setValue("upload_img", row.image_menu);
    setValue("image_menu", row.img); //id value
    const imageUrl = `${IMAGE_BASE_URL}${row.img}`;
    setValue("upload_image", imageUrl); //image_url value
    setValue("upload_img", row.upload_img); //image VALUE
    setValue("order", row.order);
    setValue("status", {
      label: row.status ? "Active" : "InActive",
      value: row.status,
    });
    setMode("Edit"); // Set mode to Edit
    setIsOpen(true); // Open the form modal
  };

  const handleImageChange = (e, errorInput, url) => {
    const file = e.target.files[0];
    if (file) {
      ValidateImg(file, (isValid) => {
        if (isValid) {
          setValue(errorInput, file); // Set as File object, not string
          const imageUrl = URL.createObjectURL(file);
          setValue(url, imageUrl);
          trigger(errorInput);
          setTimeout(() => clearErrors(errorInput), 100);
        } else {
          setError(errorInput, {
            type: "manual",
            message: "Invalid file type. Only PNG, JPEG, and JPG files are allowed.",
          });
          e.target.value = "";
        }
      });
    } else {
      setValue(errorInput, "");
    }
  };
  const handleImageClose = () => {
    setImageOpen(!imageOpen);
  };
  const handleImageOpenPreview = (row) => {
    setImageOpen(!imageOpen);
    setValue("image_preview", row);
    trigger("image_preview");
  };

  const handleStatusChange = (selectedOption) => {
    setValue("status", selectedOption || "");
    trigger("status");
  };

  useEffect(() => {
    getManageListAPI();
  }, []);
  const getManageListAPI = () => {
    const data = {};
    getManageDirAPI(data)
      .then((res) => {
        const status = decrypt(res.data.status);
        if (status === "success") {
          const decryptedResponse = decrypt(res.data.data.tableData);
          toast.success(res.data.message);
          setData(decryptedResponse);
          toast.clearWaitingQueue();
        } else if (status === "failed") {
          toast.warning(res.data.message);
          toast.clearWaitingQueue();
          setData([]);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const module = "ManagementDir";

  const onFormSubmit = async (data) => {
    const formData = new FormData();

    //First Name Fields
    formData.append("en_first_name", data.name);
    formData.append("hn_first_name", data.name_hindi);

    // Last Name Fields
    formData.append("en_last_name", data?.l_name || "");
    formData.append("hn_last_name", data?.l_name_hindi || "");

    // Designation Fields
    formData.append("en_designation", data.designation);
    formData.append("hn_designation", data.designation_hindi);

    formData.append("email", data.emails);
    formData.append("phone", data.phones);

    // Image Upload
    if (data.upload_img) {
      formData.append("img", data.upload_img);
    }

    // Order
    formData.append("order", data.order);

    // Status
    formData.append("status", data.status.value);
    formData.append("module", module);
    const newFd = new FormData();
    if (mode == "Edit") {
      formData.append("id", watch("id"));
    }
    const encryptedData = await encryptFormData(formData);
    newFd.append("zero", encryptedData);
    if (watch("upload_image") == null) {
      // newFd.append("img", data?.upload_img[0]);
    } else {
      newFd.append("img", data?.upload_img);
    }

    if (mode === "Add") {
      addMngmntDirAPI(newFd)
        .then((res) => {
          const status = decrypt(res.data.status);
          if (status == "success") {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            getManageListAPI();
            setIsOpen(false);
            setIsLoading(false);
          } else if (status === "failed") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (status === "expired") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setIsLoading(false);
        });
    }
    // ID (for Edit Mode)
    if (mode === "Edit") {
      editManageDirAPI(newFd)
        .then((res) => {
          const status = decrypt(res.data.status);

          if (status == "success") {
            toast.success(res.data.message);
            getManageListAPI();
            setIsOpen(false);
            setIsOpen(false);
            setIsLoading(false);
          } else if (status === "failed") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (status === "expired") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setIsLoading(false);
        });
    }
  };

  const handleToggleStatus = (row) => {
    setValue("id", row.id);
    setValue("status", row.status);
    setShowModal(true);
  };
  const confirmStatusChange = () => {
    const data = {
      id: watch("id"),
      status: watch("status"),
    };

    const encryptData = encrypt(data);
    const encryptedData = {
      zero: encryptData,
    };

    updateMgmntDirStatusAPI(encryptedData)
      .then((res) => {
        const status = decrypt(res.data.status);
        if (status == "success") {
          getManageListAPI();
          toast.success(res.data.message);
          toast.clearWaitingQueue();
        } else if (status === "failed") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        toast.error(err.message);
        setIsLoading(false);
      });
    setShowModal(false);
  };
  const toggleDelete = (row) => {
    setValue("deleteRow", row);
    setShowDelete(true);
  };
  const handleDelete = () => {
    const data = {
      id: watch("deleteRow")?.id,
    };
    setIsLoading(true);
    const encryptData = encrypt(data);
    const encryptedData = {
      zero: encryptData,
    };
    deleteMgmntDirStatusAPI(encryptedData)
      .then((res) => {
        const status = decrypt(res.data.status);
        if (status == "success") {
          getManageListAPI();
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          setIsLoading(false);

          setShowDelete(false);
        } else if (status === "failed") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          setIsLoading(false);
        } else if (status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        toast.error(err.message);
        setIsLoading(false);
      });
  };

  return (
    <>
      <Head title={"Directory Management"} />
      <Content>
        <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Management Directory"}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  onClick={() => {
                    setIsOpen((pre) => !pre);
                    setMode("Add");
                    reset();
                  }}
                >
                  <Icon name={isOpen ? "minus" : "plus"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <Row className={`g-gs`}>
            {isOpen && (
              <PreviewAltCard>
                <Form onSubmit={handleSubmit(onFormSubmit)}>
                  <Row>
                    <Col md="12" className={`mb-5`}>
                      <div className="form-group">
                        <Label className="form-label">First Name</Label>
                        <div className="w-100 d-flex gap-2">
                          <div className="w-100">
                            <input
                              id="name"
                              placeholder="Enter First Name (English)"
                              type="text"
                              className="form-control"
                              {...register("name", {
                                required: "First Name is required",
                              })}
                            />
                            {errors.name && (
                              <span
                                style={{
                                  color: "#e85347",
                                  fontSize: "11px",
                                  fontStyle: "italic",
                                }}
                              >
                                {errors.name.message}
                              </span>
                            )}
                          </div>
                          <div className="w-100">
                            <input
                              id="name_hindi"
                              placeholder="नाम दर्ज करें (Hindi)"
                              type="text"
                              className="form-control"
                              {...register("name_hindi", {
                                required: "हिंदी में पहला नाम आवश्यक है",
                                pattern: {
                                  value: /^[\u0900-\u097F\s0-9.,|!@#$%^&*()_+\-={}\[\]:";'<>?/\\~`]+$/,
                                  message: "केवल हिंदी में दर्ज करें",
                                },
                              })}
                            />
                            {errors.name_hindi && (
                              <span
                                style={{
                                  color: "#e85347",
                                  fontSize: "11px",
                                  fontStyle: "italic",
                                }}
                              >
                                {errors.name_hindi.message}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </Col>

                    {/* Last Name */}

                    <Col md="12" className={`mb-5`}>
                      <div className="form-group">
                        <Label className="form-label">Last Name</Label>
                        <div className="w-100 d-flex gap-2">
                          <div className="w-100">
                            <input
                              id="l_name"
                              placeholder="Enter Last Name (English)"
                              type="text"
                              className="form-control"
                              {...register("l_name", {
                                // required: "Last Name is required",
                              })}
                            />
                            {errors.l_name && (
                              <span
                                style={{
                                  color: "#e85347",
                                  fontSize: "11px",
                                  fontStyle: "italic",
                                }}
                              >
                                {errors.l_name.message}
                              </span>
                            )}
                          </div>
                          <div className="w-100">
                            <input
                              id="l_name_hindi"
                              placeholder="नाम दर्ज करें (Hindi)"
                              type="text"
                              className="form-control"
                              {...register("l_name_hindi", {
                                // required: "हिंदी में अंतिम नाम आवश्यक है",
                                pattern: {
                                  value: /^[\u0900-\u097F\s0-9.,|!@#$%^&*()_+\-={}\[\]:";'<>?/\\~`]+$/,
                                  message: "केवल हिंदी में दर्ज करें",
                                },
                              })}
                            />
                            {errors.l_name_hindi && (
                              <span
                                style={{
                                  color: "#e85347",
                                  fontSize: "11px",
                                  fontStyle: "italic",
                                }}
                              >
                                {errors.l_name_hindi.message}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </Col>

                    {/* Designation */}

                    <Col md="12" className={`mb-5`}>
                      <div className="form-group">
                        <Label className="form-label me-3">Designation</Label>
                        <div className="w-100 d-flex gap-2">
                          <div className="w-100">
                            <input
                              id="designation"
                              placeholder="Enter Designation (English)"
                              type="text"
                              className="form-control"
                              {...register("designation", {
                                required: "Designation is required",
                              })}
                            />
                            {errors.designation && (
                              <span
                                style={{
                                  color: "#e85347",
                                  fontSize: "11px",
                                  fontStyle: "italic",
                                }}
                              >
                                {errors.designation.message}
                              </span>
                            )}
                          </div>
                          <div className="w-100">
                            <input
                              id="designation_hindi"
                              placeholder="पदनाम दर्ज करें (Hindi)"
                              type="text"
                              className="form-control"
                              {...register("designation_hindi", {
                                required: "हिंदी में पदनाम आवश्यक है",
                                pattern: {
                                  value: /^[\u0900-\u097F\s0-9.,|!@#$%^&*()_+\-={}\[\]:";'<>?/\\~`]+$/,
                                  message: "केवल हिंदी में दर्ज करें",
                                },
                              })}
                            />
                            {errors.designation_hindi && (
                              <span
                                style={{
                                  color: "#e85347",
                                  fontSize: "11px",
                                  fontStyle: "italic",
                                }}
                              >
                                {errors.designation_hindi.message}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </Col>

                    {/* Email Fields */}

                    <Col md="6" className={`mb-4`}>
                      <div className="form-group">
                        <label className="form-label">Emails</label>
                        <input
                          id="emails"
                          type="text"
                          className="form-control"
                          placeholder="Enter emails separated by /"
                          {...register("emails", {
                            required: "Email field is required",
                            validate: (value) => {
                              if (!value) return "Email field is required";
                              if (
                                !/^([\w.%+-]+@[\w.-]+\.[a-zA-Z]{2,})(\/([\w.%+-]+@[\w.-]+\.[a-zA-Z]{2,}))*$/.test(value)
                              ) {
                                return "Enter valid emails separated only by /";
                              }
                              return true;
                            },
                          })}
                        />
                        {errors.emails && (
                          <span
                            className="invalid"
                            style={{
                              color: "#e85347",
                              fontSize: "11px",
                              fontStyle: "italic",
                            }}
                          >
                            {errors.emails.message}
                          </span>
                        )}
                      </div>
                    </Col>
                    <Col md={6} className={``}>
                      <div className="form-group">
                        <label className="form-label">Phones</label>
                        <input
                          id="phones"
                          type="text"
                          className="form-control"
                          placeholder="Enter phone numbers separated by ,"
                          {...register("phones", {
                            required: "Phone field is required",
                            validate: (value) => {
                              if (!value) return "Phone field is required";
                              if (!/^([0-9]{10})(,([0-9]{10}))*$/.test(value)) {
                                return "Enter valid 10-digit phone numbers separated only by commas";
                              }
                              return true;
                            },
                          })}
                        />
                        {errors.phones && (
                          <span
                            className="invalid"
                            style={{
                              color: "#e85347",
                              fontSize: "11px",
                              fontStyle: "italic",
                            }}
                          >
                            {errors.phones.message}
                          </span>
                        )}
                      </div>
                    </Col>
                    {/* <Col md="6" className={`mb-4`}>
                      <div className="form-group">
                        <MyCreatableInput
                          placeholder={"Type valid email and press enter..."}
                          errors={errors}
                          name={"emails"}
                          register={register}
                          setValue={setValue}
                          trigger={trigger}
                          getValues={getValues}
                          setError={setError}
                          email
                        />
                      </div>
                    </Col>
                    <Col md={6} className={``}>
                      <div className="form-group">
                        <MyCreatableInput
                          placeholder={"Type valid mobile and press enter..."}
                          errors={errors}
                          name={"phones"}
                          register={register}
                          setValue={setValue}
                          trigger={trigger}
                          getValues={getValues}
                          setError={setError}
                          mobile
                        />
                      </div>
                    </Col> */}

                    {/* image upload */}
                    <ImageUpload
                      id="image_menu"
                      watch={watch}
                      label={"Upload Banner"}
                      errors={errors}
                      register={register}
                      image={"upload_img"}
                      image_url={"upload_image"}
                      handleImageChange={handleImageChange}
                      setValue={setValue}
                      handleImageOpenPreview={handleImageOpenPreview}
                    />

                    {/* Order */}

                    <Col md="4">
                      <div className="form-group">
                        <Label className="form-label">Order</Label>
                        <input
                          id="order"
                          placeholder="Enter Order"
                          type="text"
                          className="form-control"
                          {...register("order", {
                            required: "Order is required",
                            pattern: {
                              value: /^[1-9][0-9]{0,2}$/,
                              message: "Order must be between 1 and 100",
                            },
                          })}
                        />
                      </div>
                      {errors.order && (
                        <span
                          className="invalid"
                          style={{
                            color: "#e85347",
                            fontSize: "11px",
                            fontStyle: "italic",
                          }}
                        >
                          {errors.order.message}
                        </span>
                      )}
                    </Col>
                    {/* status  */}

                    <Col md="3">
                      <div className="form-group">
                        <Label className="from-label" htmlFor="status">
                          Status
                        </Label>
                        <div className="form-control-wrap">
                          <Select
                            id="status"
                            options={[
                              { value: true, label: "Active" },
                              { value: false, label: "InActive" },
                            ]}
                            {...register("status", {
                              required: "Please select status",
                            })}
                            onChange={handleStatusChange}
                            value={watch("status")}
                          />
                          {errors.status && (
                            <span
                              className="invalid"
                              style={{
                                color: "#e85347",
                                fontSize: "11px",
                                fontStyle: "italic",
                              }}
                            >
                              {errors?.status?.message}
                            </span>
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Col md="2" className={``}>
                    <div className="form-group" style={{ marginTop: "31px" }}>
                      <Button disabled={isLoading} color="primary" size="md">
                        {isLoading ? <Spinner size="sm" color="primary" /> : mode == "Add" ? "Save" : "Update"}
                      </Button>
                    </div>
                  </Col>
                </Form>
              </PreviewAltCard>
            )}
            <ViewImage url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />
            <MyDataTable data={data} columns={column} title="Directory Data" isLoading={isLoading} />
          </Row>
        </Block>
      </Content>

      {/* Confirmation Modal */}
      <ConfirmModal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        onConfirm={confirmStatusChange}
        status={watch("status")}
      />
      {/* Delete Confirmation Modal */}
      <DeleteModal
        deleteModal={showDelete}
        toggleDeleteModal={()=>setShowDelete(false)}
        name={watch("deleteRow")?.en_first_name + watch("deleteRow")?.en_last_name}
        handleDelete={handleDelete}
        rowData={watch("deleteRow")}
        loading={isLoading}
      />
    </>
  );
};

export default MgmntDirectry;
